import NumbersCarousel from './NumbersCarousel'

export default NumbersCarousel
